import { FilterState } from '../interfaces/attendance-list-filter.interface';
import { AttendanceStatus } from '../interfaces/attendance-status.enum';

export function attendanceStatusToArray(
  data: FilterState['attendanceStatus']
): AttendanceStatus[] {
  const attendanceStatuses: AttendanceStatus[] = [];

  if (data.archived) attendanceStatuses.push(AttendanceStatus.ARCHIVED);
  if (data.opened) attendanceStatuses.push(AttendanceStatus.OPENED);
  if (data.closed) attendanceStatuses.push(AttendanceStatus.CLOSED);

  return attendanceStatuses;
}
